import React from 'react';

export type CapabilityStatus = 'in-development' | 'coming-soon';

const STYLES: Record<CapabilityStatus, { label: string; className: string }> = {
  'in-development': {
    label: 'In Development',
    className: 'bg-neon-blue/10 text-neon-blue border-neon-blue/30',
  },
  'coming-soon': {
    label: 'Coming Soon',
    className: 'bg-white/5 text-gray-400 border-white/10',
  },
};

const StatusBadge: React.FC<{ status: CapabilityStatus }> = ({ status }) => {
  const { label, className } = STYLES[status];
  return (
    <span className={`inline-block text-xs font-medium px-3 py-1 rounded-full border ${className}`}>
      {label}
    </span>
  );
};

export default StatusBadge;
